import React from "react";
import { Account } from "./types";
import { Connection } from "./types/connection";

export interface AppContextModel {
  connections: Connection[];
  account: Account | null;
  selectedArtist: string | null;
  setSelectedArtist: (x: string | null) => void;
  selectHqIsActive: boolean;
  setHqIsActive: (x: boolean) => void;
  reloadAccount: () => void;
}
const AppContext = React.createContext<AppContextModel>({
  connections: [],
  account: null,
  selectedArtist: null,
  reloadAccount: () => { },
  setSelectedArtist: () => { },
  selectHqIsActive: false,
  setHqIsActive: () => { }
});

export default AppContext;